import script from "./PortfolioSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioSwitcher.vue?vue&type=style&index=0&id=5bd99b54&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd99b54"]])

export default __exports__